import { DataView24, Edit24 } from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Add16, Document16 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  TextInput,
  Select,
  SelectItem,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import useAuth from "../../hooks/useAuth";
import http from "../../http-common";
import * as XLSX from "xlsx";

const tableHeaders = [
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "NUR",
    key: "nur",
  },
  {
    header: "Janela",
    key: "window",
  },
  {
    header: "Sexo",
    key: "gender",
  },

  {
    header: "Estado",
    key: "status",
  },
  {
    header: " ",
    key: "actions",
  },
];

const LinkList = ({ url, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url2} title="Consultar">
        <DataView24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return <LinkList url2={"../plano-de-negocio/" + id} />;
  }
  return cell.value;
};

const ListBusinessPlansPage = () => {
  const { isMentor } = useAuth();
  const [loading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [exportDataXls, setExportDataXls] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(isMentor ? 50 : 20);
  const [searchFilters, setSearchFilters] = useState({});

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const buildSearchUrl = (filters = {}, page = 0, pageSize = size) => {
    const params = new URLSearchParams({ page, size: pageSize });
    if (isMentor) params.set("competitor.isWinner", "true");
    if (filters.name) params.set("competitor.name", filters.name);
    if (filters.nur) params.set("nur", filters.nur);
    if (filters.submissionWindow) {
      params.set("submissionWindow", filters.submissionWindow);
    }
    return `/business-plan/search/q?${params.toString()}`;
  };

  const featchData = async () => {
    try {
      const response = await http.get(buildSearchUrl({}, 0, size));
      getApplicationData(response);
    } catch (error) {}
  };

  const featchExport = async () => {
    try {
      const response = await http.get(`business-plan/export`);
      getExportData(response);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      setLoading(true);
      var pag = page - 1;
      setSize(pageSize);
      const response = await http.get(buildSearchUrl(searchFilters, pag, pageSize));
      getApplicationData(response);
    } catch (error) {}
  };

  const onSearch = async (data) => {
    try {
      setLoading(true);
      const filters = {
        name: data.name || "",
        nur: data.nur || "",
        submissionWindow: data.submissionWindow || "",
      };
      setSearchFilters(filters);
      const response = await http.get(buildSearchUrl(filters, 0, size));
      getApplicationData(response);
    } catch (error) {}
  };

  const getApplicationData = (response) => {
    const data = response.data.content.map((bp) => ({
      id: bp.uuid,
      nur: bp.nur,
      window: bp.windowDesc,
      name: bp.name,
      gender: bp.gender,
      status: bp.currentStatusDesc,
    }));
    setApps(data);
    setCount(response.data.totalElements);
    setLoading(false);
  };

  const getExportData = (response) => {
    const data = response.data.map((bp) => ({
      id: bp.uuid,
      name:
        bp.name ||
        bp.fullName ||
        [bp.firstName, bp.lastName].filter(Boolean).join(" "),
      gender: bp.genderEnum.description,
      provinceName: bp.provinceName,
      districtName: bp.districtName,
      status: bp.currentStatusDesc,
      email: bp.email,
      phoneNumber1: bp.phoneNumber1,
    }));
    setExportDataXls(data);
    // setCount(response.data.totalElements);
    setLoading(false);
  };

  const exportXLS = () => {
    const date = new Date().toLocaleDateString();

    const data = exportDataXls.map((st) => ({
      Nome: st.name,
      Genero: st.gender,
      Provincia: st.provinceName,
      Distrito: st.districtName,
      Status: st.status,
      email: st.email,
      Telefone: st.phoneNumber1,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Planos de Negócio");

    XLSX.writeFile(wb, `Planos de Negocio_${date}.xlsx`);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Planos de Negócio">
      <Loading
        active={loading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <DataTable rows={apps} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            {!isMentor && (
              <TableToolbar aria-label="data table toolbar">
                <TableToolbarContent>
                  {/* <TableToolbarSearch
                  placeholder="Digite o número de telefone para pesquisar"
                  onChange={(e) => search(e.target.value)}
                /> */}
                  <Form
                    className="data-table-search-form"
                    onSubmit={handleSubmit(onSearch)}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "minmax(12rem, 2fr) minmax(9rem, 1fr) minmax(9rem, 1fr) auto",
                      alignItems: "end",
                      gap: "0.5rem",
                      width: "100%",
                    }}
                  >
                    <TextInput
                      id="name"
                      labelText=""
                      placeholder="Nome"
                      {...register("name")}
                    />
                    <TextInput
                      id="nur"
                      labelText=""
                      placeholder="NUR"
                      {...register("nur")}
                    />
                    <Select
                      id="submissionWindow"
                      labelText=""
                      {...register("submissionWindow")}
                    >
                      <SelectItem value="" text="Todas as janelas" />
                      <SelectItem value="JANELA_1" text="Janela 1" />
                      <SelectItem value="JANELA_2" text="Janela 2" />
                    </Select>
                    <Button type="submit" size="sm" renderIcon={Search32}>
                      Pesquisar
                    </Button>
                    {/* <Button
                      style={{ marginLeft: "0.1rem" }}
                      onClick={exportXLS}
                      renderIcon={Document16}
                    >
                      Exportar
                    </Button> */}
                  </Form>
                </TableToolbarContent>
              </TableToolbar>
            )}
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      {!isMentor && (
        <TablePagination
          currentPageSize={size}
          onPageChange={onPageChange}
          totalItems={count}
        />
      )}
    </Card>
  );
};

export default ListBusinessPlansPage;
